import DynamicSectionElement from '@/scripts/dynamic-section-element.js'
import { setRecentlyViewed } from '@/scripts/recently-viewed'
import { formatMoney } from '@/scripts/formatMoney'
import { getInstructionManuals } from '@/services/product-registration'

import './components/product-main-price'

class ProductMain extends DynamicSectionElement {
  constructor () {
    super()

    setRecentlyViewed(this.dataset.handle)

    const sku = this.dataset.sku

    if (sku) {
      getInstructionManuals(sku).then(data => {
        if (data && data.length > 0) {
          let html = ''
          data.forEach((url, index) => {
            const el = `
                    <div class="relative">
                        <div class="flex">
                          <svg class="w-[11px] mr-[6px] lg:mr-2" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.204 3.676H1.446V17.15H12.48V3.676H9.72" stroke="#000"/><path d="m9.403 7.837-2.44 2.44-2.44-2.44M6.962.207v10.048" stroke="#000"/></svg>
                          <a class="flex items-center font-bold underline" href=${url} target="_blank">
                            Download Product Manual ${index + 1}
                            <span class="sr-only">Opens a new window</span>
                          </a>
                        </div>
                    </div>
            `
            html += el
          })

          const productManualEl = document.querySelector('.js-product-manual')
          const contactUsEl = document.querySelector('.js-contact-us')
          if (productManualEl) {
            productManualEl.insertAdjacentHTML('afterbegin', html)
            if (contactUsEl) {
              contactUsEl.classList.add('hidden')
            }
          }
        }
      })
    }

    // Replace dynamic product content when changing variant options
    this.addEventListener('change-variant', (event) => {
      const { origin, pathname } = window.location
      const params = new URLSearchParams({
        variant: event.detail.id
      })

      this
        .loadSectionFromUrl(`${origin}${pathname}?${params}`, { replaceState: true })
        .then(() => {
          // Rebind PriceSpider button if new section contains one
          if (this.querySelector('.ps-widget') && window.PriceSpider) {
            window.PriceSpider.rebind()
          }
        })
    })

    if (this.dataset.isBundle === 'true') {
      this.addEventListener('load-bundle-components', (event) => {
        const totalPrice = Object.keys(event.detail).reduce((sum, key) => {
          return sum + Number(event.detail[key].variants.nodes[0].price.amount)
        }, 0)
        const price = parseFloat(this.dataset.price.replace( /[^\d\.]*/g, ''))
        const discount = Math.round((1 - price/totalPrice) * 100)
        const priceEls = this.querySelectorAll('product-main-price')
          priceEls.forEach((priceEl) => {
            priceEl.setAttribute('price', this.dataset.price)
            priceEl.setAttribute('compare-at-price', formatMoney(totalPrice.toFixed(2)))
            if (this.dataset.isBundle !== 'false' && discount > 0) {
              priceEl.setAttribute('discount-percent', discount)
              const discountEl = document.createElement('span')
              discountEl.classList.add('h5', 'border', 'border-blue', 'rounded-3xl', 'ml-2', 'px-2', 'py-1', 'inline-block')
              discountEl.innerHTML = `Save ${discount}% when bundling!`
              priceEl.appendChild(discountEl)
            }
            priceEl.removeAttribute('hidden')
          })
      })
    }

    if (this.querySelector('[data-slot="bundle-product-mini-card"]')) {
      this.renderBundleProductMiniCard()
    }

    const psWidget = this.querySelector('.ps-widget')
    if (psWidget) {
      if (psWidget.classList.contains('ps-enabled') || psWidget.classList.contains('ps-disabled')) {
        this.removePriceSpiderCss()
      } else {
        const widgetObserver = new MutationObserver(() => {
          if (this.removePriceSpiderCss()) {
            widgetObserver.disconnect()
          }
        })
        widgetObserver.observe(psWidget, { attributes: true });
      }
    }

    this.reviewsAnchor()
  }

  removePriceSpiderCss() {
    const buttonCss = document.querySelector('link[href*="cdn.pricespider.com"][href$="button.css"]')

    if (buttonCss) {
      buttonCss.parentElement.removeChild(buttonCss)
      return true
    }
  }

  reviewsAnchor () {
    const targetNode = document.body;
    const config = { attributes: true, childList: true, subtree: true };

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          const inlineRatings = document.querySelectorAll('a.bv_main_container')
          const reviewsSection = document.querySelector('#bv-reviews')
          if (inlineRatings && reviewsSection) {
            inlineRatings.forEach(item => {
              item.addEventListener('click', (e) => {
                e.preventDefault()
                const y = reviewsSection.getBoundingClientRect().top + window.pageYOffset
                window.scrollTo({top: y, behavior: 'smooth'})
              })
            })
          }
        }
      }
    }

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  getIdProduct (text) {
    return parseInt(text.split('/').pop())
  }
}

if (!customElements.get('product-main')) {
  customElements.define('product-main', ProductMain)
}